import { render, staticRenderFns } from "./ServiceRequestList.vue?vue&type=template&id=855c468a&scoped=true"
import script from "./ServiceRequestList.vue?vue&type=script&lang=js"
export * from "./ServiceRequestList.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestList.vue?vue&type=style&index=0&id=855c468a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c468a",
  null
  
)

export default component.exports